// extracted by mini-css-extract-plugin
export var page = "Layout-module--page--1casD";
export var bgGrey = "Layout-module--bg-grey--2X8Tr";
export var bgBlack = "Layout-module--bg-black--1s56B";